
(function ($) {

  $(document).ready(() => {

    $('.modal-overlay , .modal-close').on('click', function (e) {
      e.preventDefault();
      $('.modal').addClass('opacity-0 pointer-events-none')
      $('body').removeClass('modal-active')
    });

    $('.modal-open').click(function (e) {
      e.preventDefault();
      const m = $(this).data("modal");
      $('#modal-' + m).toggleClass('opacity-0 pointer-events-none')
      $('body').toggleClass('modal-active')
    });

  });
})(jQuery);
